import React from 'react'
import PropTypes from 'prop-types'
import {FaIcon} from '../components'

export const GGChip = ({
  label,
  selected = false,
  onClick,
  multiselect = false,
  name,
  value,
  disabled = false,
  className,
}) => {
  const cls = [
    'gg-chip',
    multiselect ? 'gg-chip--multi' : 'gg-chip--single',
    selected ? 'gg-chip--selected' : '',
    disabled ? 'gg-chip--disabled' : '',
    className,
  ].filter(Boolean).join(' ')

  const handleKey = (e) => {
    if (disabled) { return }
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <label className={cls} tabIndex={disabled ? undefined : 0} onKeyDown={handleKey}>
      <input
        type={multiselect ? 'checkbox' : 'radio'}
        className="gg-chip__input"
        name={name}
        value={value}
        checked={selected}
        disabled={disabled}
        onChange={disabled ? undefined : onClick}
      />
      {multiselect && (
        <span className="gg-chip__check">
          <span className="gg-chip__check-box">
            <span className="gg-chip__check-icon"><FaIcon icon='check-o' usePro/></span>
          </span>
        </span>
      )}
      <span className="gg-chip__label">{label}</span>
    </label>
  )
}

GGChip.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  multiselect: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}
